
import { defineComponent, ref } from "vue";
import RadioButton from "primevue/radiobutton";
import Dialog from "primevue/dialog";
import NextStepButton from "@/components/NextStepButton.vue";

export enum DeliveryOptions {
  DIY = "DIY Route",
  KIT = "Finished KIT",
}

export default defineComponent({
  name: "Delivery",
  components: { RadioButton, Dialog, NextStepButton },
  props: {
    numConnectors: {
      type: Number,
      default: 0,
    },
    numEdges: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const deliveryOption = ref();
    const formatToDollar = (dollarAmount: number) => {
      return dollarAmount.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    };
    const isMobile = () => {
      return window.outerWidth < 376;
    };
    const toCheckout = () => {
      display.value = false;
      if (deliveryOption.value) {
        emit("toCheckout", deliveryOption.value);
      }
    };
    const display = ref(false);
    return {
      deliveryOption,
      formatToDollar,
      isMobile,
      display,
      toCheckout,
      DeliveryOptions,
    };
  },
});
